<template>
	<div class="flex items-center -mr-2 md:hidden">
		<!-- Collapsed Mobile menu button -->
		<DisclosureButton
			class="inline-flex items-center justify-center p-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-mx-navy focus-visible:ring-mx-orange focus-visible:ring-opacity-80"
			:class="color"
		>
			<span class="sr-only">
				<!-- TODO i18n -->
				Open main menu
			</span>
			<Bars3Icon
				class="block w-6 h-6"
				aria-hidden="true"
			/>
		</DisclosureButton>
	</div>
</template>

<script setup lang="ts">
import { DisclosureButton } from '@headlessui/vue'
import { Bars3Icon } from '@heroicons/vue/24/outline'

defineProps({
	color: {
		type: String,
		default: 'text-mx-gray-400'
	}
})
</script>
